import React from 'react'

const ClassicWeddingBands = () => {
  return (
    <iframe scrolling="yes" width="100%" height="11000px" frameborder="0" sandbox="allow-scripts allow-forms allow-same-origin" src="https://morgantaylor-frame-categoryembed.jewelershowcase.com/classicweddingbands"></iframe>
  )
}

export default ClassicWeddingBands
